import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../utils/ThemeContext';
import './ThemeToggle.css';

const ThemeToggle = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <div className="footer-theme-toggle">
            <span>{theme === 'dark' ? 'Modo oscuro' : 'Modo claro'}</span>
            <button
                className="theme-toggle"
                onClick={toggleTheme}
                aria-label={`Cambiar a tema ${theme === 'dark' ? 'claro' : 'oscuro'}`}
            >
                {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
            </button>
        </div>
    );
};

export default ThemeToggle;
